"use strict";

exports.__esModule = true;
exports.ToolBarItems = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ToolBarItem = require("./ToolBarItem");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ToolBarItems = ({
  items,
  defaultSelection,
  children
}) => {
  const [selectedItem, setSelectedItem] = (0, _react.useState)(defaultSelection || 'show-all');
  const classes = ['ccl-e-tool-bar__item', 'ccl-e-tool-bar__item--confine'];
  if (children) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.join(' '),
      children: children
    });
  }
  (0, _react.useEffect)(() => {
    setSelectedItem(defaultSelection);
  }, [defaultSelection]);
  return items.map(({
    type,
    text,
    linkTo,
    onHandle,
    align,
    icon,
    iconAlign,
    sections,
    routerLink,
    analytics
  }) => {
    const toolBarItemConfig = {
      type,
      text,
      linkTo: linkTo ? {
        to: linkTo
      } : null,
      onHandle,
      align,
      icon,
      iconAlign,
      sections,
      routerLink,
      analytics
    };
    if (type === 'breadcrumb') classes.splice(1, 1, 'ccl-e-tool-bar__item--grow');
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.join(' '),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolBarItem.ToolBarItem, {
        config: toolBarItemConfig,
        selectedItem: selectedItem,
        setSelectedItem: setSelectedItem
      })
    }, `tool-bar__item__${type}__${text}`);
  });
};
exports.ToolBarItems = ToolBarItems;